import React, { useState, useEffect } from 'react'
import { useDispatch, useStore, useSelector } from 'react-redux'
import ds from '../../../Services/DataServices'
import { useHistory } from 'react-router'
import {
  Card,
  Table,
  Button,
  Row,
  Col,
  Spin,
  Breadcrumb,
  DatePicker,
  Modal,
  Form,
  Divider,
  message
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import { REPORT_CLOSURE } from '../../../constants/Pages'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import {
  isEmptyObject,
  checkRightspermissions,
  getDecryptID,
  notAllowMsgCheck,
  formatDigits,
  verifyPkgFeature
} from '../../../appRedux/actions/GlobalMethods'
import moment from 'moment'
import { RollbackOutlined } from '@ant-design/icons'
import { checkIsWeb, postDataToApp } from '../../../appRedux/actions/MobAppFn'
import { PostAppTypes } from '../../../constants/MobAppConstants'
import NotAllowedComponent from '../../../components/NotAllowedComponent'
import { PkgFeatures } from '../../../constants/StoreEntities'

const FullDetail = props => {
  const { id } = props.match.params
  const dispatch = useDispatch()
  const history = useHistory()
  const [form] = Form.useForm()

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const getDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )

  const [getIsLoading, setIsLoading] = useState(true)
  const [getData, setData] = useState({})
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencySymbol: ''
  })
  const [isFeatureAllowed, setIsFeatureAllowed] = useState(true)

  useEffect(() => {
    let mounted = true
    if (mounted) {
      if (!verifyPkgFeature(PkgFeatures.ReportingAndAnalytics)) {
        setIsFeatureAllowed(false)
      }

      if (!checkIsWeb().exist) {
        postDataToApp(PostAppTypes.PAGE_HEADER, 'report.register.transaction')
      }

      dispatch(setCommonConfigs(REPORT_CLOSURE))
      if (id) {
        getRegClosureDetailService(
          { CashRegPaymentID: id },
          PkgFeatures.ReportingAndAnalytics
        )
      } else {
        setIsLoading(false)
        message.warn('Something is wrong')
        setTimeout(() => {
          history.push('/dashboard/reporting/registerclosures/listing')
        }, 2000)
      }
    }
    return () => (mounted = false)
  }, [])

  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      const commonData = getReduxCommonSetting
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrData(currencyData)
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)
          setAccessLoading(false)
        } else {
          toInitialState()
          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }
    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }
    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }

  function toInitialState () {
    setRights([])
    setPermissions([])
    setIsAllowRead(false)
    setIsDisableCreate(true)
    setIsDisableUpdate(true)
    setIsDisableDelete(true)
    setAccessLoading(true)
  }

  async function getRegClosureDetailService (body, featureID) {
    await ds
      .getRegClosureDetail(body, BEHAVIOUR_TYPE.GET, featureID)
      .then(data => {
        setIsLoading(false)
        if (data && !isEmptyObject(data)) {
          if (data.detail && data.detail.length > 0) {
            let totalPaid = 0
            let totalSale = 0
            let change = 0
            data.detail.map(qw => {
              totalPaid += qw.totalPaid
              totalSale += qw.totalSale
              change += qw.change ? qw.change : 0
            })
            const totalRow = {
              key: 'total',
              totalPaid,
              totalSale,
              change
            }
            data.detail.push(totalRow)
          }
          setData(data)
        } else {
          setData({})
        }
      })
      .catch(e => {
        setIsLoading(false)
        notAllowMsgCheck(e)
      })
  }

  const columns = [
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      fixed: 'left',
      render: (text, record) => {
        return record && record.key == 'total' ? (
          <strong>Total</strong>
        ) : (
          <span>{text ? moment(text).format('MMMM DD/YYYY h:mma') : ''}</span>
        )
      }
    },
    {
      title: 'Receipt',
      dataIndex: 'receipt',
      key: 'expected'
    },
    {
      title: 'User',
      dataIndex: 'user',
      key: 'user',
      render: (text, record) => {
        return <span>{record.soldBy ? record.soldBy : ''}</span>
      }
    },
    {
      title: 'Customer',
      dataIndex: 'customer',
      key: 'customer',
      render: (text, record) => {
        return (
          <span>
            {record.cusFirstName
              ? `${record.cusFirstName} ${record.cusLastName}`
              : ''}
          </span>
        )
      }
    },
    {
      title: 'Notes',
      dataIndex: 'notes',
      key: 'notes'
    },
    {
      title: 'Total Price',
      dataIndex: 'products',
      key: 'products',
      innerWidth: 100,
      outerWidth: 100,
      render: (text, record) => {
        const saleTotal = record.totalSale
          ? `${getCurrData.currencySymbol} 
          ${formatDigits(record.totalSale, getDecimalPlaces)}`
          : '0.00'
        return record && record.key == 'total' ? (
          <strong>{saleTotal}</strong>
        ) : (
          <span>{saleTotal}</span>
        )
      }
    },
    {
      title: 'Total Paid',
      dataIndex: 'totalSale',
      key: 'totalSale',
      render: (text, record) => {
        const paid = record.totalPaid
          ? `${getCurrData.currencySymbol} 
          ${formatDigits(record.totalPaid, getDecimalPlaces)}`
          : '0.00'
        return record && record.key == 'total' ? (
          <strong>{paid}</strong>
        ) : (
          <span>{paid}</span>
        )
      }
    },
    {
      title: 'Change',
      dataIndex: 'change',
      key: 'change',
      render: (text, record) => {
        const change = record.change
          ? `${getCurrData.currencySymbol} 
          ${formatDigits(record.change, getDecimalPlaces)}`
          : '0.00'
        return record && record.key == 'total' ? (
          <strong>{change}</strong>
        ) : (
          <span>{change}</span>
        )
      }
    }
  ]

  return getIsAllowRead && isFeatureAllowed ? (
    <Spin
      tip={<IntlMessages id='sell.cashlisting.cashloading' />}
      spinning={getIsLoading}
      size='large'
    >
      <div className='Content-wrapper FullDetail-header'>
        <Row className='dk-flex-space-bw align-items-center justify-content-center mb-3'>
          <Col lg={12} md={12} sm={24} xs={24}>
            <h1 className='mb-0'>
              <IntlMessages id='discount.reporting.regclose' />
            </h1>
          </Col>
          <Col lg={12} md={12} sm={24} xs={24}>
            <Button
              className='BacktoSummary'
              type='primary'
              size='large'
              onClick={() => {
                history.push(
                  `/dashboard/reporting/registerclosures/summary/${id}`
                )
              }}
              icon={<RollbackOutlined className='dk-btn-icon-align' />}
            >
              <IntlMessages id='discount.reporting.back' />
            </Button>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Card className='gx-card'>
              <div className='dk-last-closer-main'>
                <div className='dk-reg-closing'>
                  <h3
                    style={{ color: '#6692b0' }}
                    className='dk-reg-closing-flex'
                  >
                    <IntlMessages id='sell.openclose.regdetail2' />
                  </h3>
                  <p>{`${getData.register ? getData.register : ''}`}</p>
                </div>
                <div className='dk-reg-closing'>
                  <h3
                    style={{ color: '#6692b0' }}
                    className='dk-reg-closing-flex'
                  >
                    <IntlMessages id='discount.reporting.sequence' />
                  </h3>
                  <p>{getData.hash ? getData.hash : ''}</p>
                </div>
                <div className='dk-reg-closing'>
                  <h3
                    style={{ color: '#6692b0' }}
                    className='dk-reg-closing-flex'
                  >
                    <IntlMessages id='sell.openclose.regdetail1' />
                  </h3>
                  <p>{getData.outlet ? getData.outlet : ''}</p>
                </div>
                <div className='dk-reg-closing'>
                  <h3
                    style={{ color: '#6692b0' }}
                    className='dk-reg-closing-flex'
                  >
                    <IntlMessages id='setup.salesTax.mainRegister.col1' />:
                  </h3>

                  <p>
                    {getData.timeOpened
                      ? moment(getData.timeOpened).format('MMMM DD/YYYY h:mma')
                      : ''}
                  </p>
                </div>
                <div className='dk-reg-closing'>
                  <h3
                    style={{ color: '#6692b0' }}
                    className='dk-reg-closing-flex'
                  >
                    <IntlMessages id='setup.salesTax.mainRegister.col2' />:
                  </h3>

                  <p>
                    {!getData.isOpen
                      ? moment(getData.timeClosed).format('MMMM DD/YYYY h:mma')
                      : 'Still Open'}
                  </p>
                </div>
              </div>
            </Card>
          </Col>
        </Row>

        <Table
          className='gx-table-responsive custom-product-table MinWidth-auto'
          // rowClassName={(record, index) => record && record.key == 'total' ? 'custom-table-row-dark' : 'gx-table-responsive'}
          columns={columns}
          dataSource={
            getData.detail && getData.detail.length > 0 ? getData.detail : []
          }
          expandable={{
            expandedRowRender: record => (
              <div style={{ margin: 0 }} className='custom-box-shadow'>
                <div style={{ height: 10 }}></div>
                <Row style={{ marginLeft: 12, marginTop: 10 }}>
                  <Col span={24}>
                    <span>
                      <strong>Products:</strong>
                    </span>
                  </Col>
                </Row>
                <Divider />
                <div style={{ marginLeft: 48 }}>
                  {record.products &&
                    record.products.length > 0 &&
                    record.products.map((e, i) => {
                      return (
                        <Row key={i}>
                          <Col span={12}>{`${e.quantity} ${e.name}`}</Col>
                          <Col span={12}>
                            {`${getCurrData.currencySymbol} 
                        ${
                          e.price
                            ? formatDigits(e.price, getDecimalPlaces)
                            : '0.00'
                        }`}
                          </Col>
                        </Row>
                      )
                    })}

                  {record.discount && record.discount > 0 ? (
                    <Row key={778899}>
                      <Col span={12}>{`-1 Discount`}</Col>
                      <Col span={12}>
                        {`${getCurrData.currencySymbol} -${formatDigits(
                          record.discount,
                          getDecimalPlaces
                        )}`}
                      </Col>
                    </Row>
                  ) : (
                    ''
                  )}
                </div>
                <Divider />
                {record.payments &&
                  record.payments.length > 0 &&
                  record.payments[0].paymentTypeID &&
                  getDecryptID(record.payments[0].paymentTypeID) != 0 && (
                    <>
                      <Row style={{ marginLeft: 12 }}>
                        <Col span={24}>
                          <span>
                            <strong>Payments:</strong>
                          </span>
                        </Col>
                      </Row>
                      <Divider />
                    </>
                  )}

                <div style={{ marginLeft: 48, marginBottom: 10 }}>
                  {record.payments &&
                    record.payments.length > 0 &&
                    record.payments[0].paymentTypeID &&
                    getDecryptID(record.payments[0].paymentTypeID) != 0 &&
                    record.payments.map((q, i) => {
                      return (
                        <Row key={i}>
                          <Col span={12}>{q.type ? q.type : ''}</Col>
                          <Col span={12}>
                            {`${getCurrData.currencySymbol} 
                        ${
                          q.price
                            ? formatDigits(q.price, getDecimalPlaces)
                            : '0.00'
                        }`}
                          </Col>
                        </Row>
                      )
                    })}
                </div>

                <div style={{ height: 14 }}></div>
              </div>
            ),
            rowExpandable: record => record.key !== 'total'
          }}
          pagination={false}
          expandRowByClick
        />
      </div>
    </Spin>
  ) : (
    <NotAllowedComponent
      getAccessLoading={getAccessLoading}
      textType={!isFeatureAllowed ? 2 : 1}
    />
  )
}
export default FullDetail
